import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_NOTIFICATION_REQUEST = 'Notification/FETCH_NOTIFICATION_REQUEST'
const FETCH_NOTIFICATION_SUCCESS = 'Notification/FETCH_NOTIFICATION_SUCCESS'
const FETCH_NOTIFICATION_FAILURE = 'Notification/FETCH_NOTIFICATION_FAILURE'

const CREATE_NOTIFICATION_REQUEST = 'Notification/CREATE_NOTIFICATION_REQUEST'
const CREATE_NOTIFICATION_SUCCESS = 'Notification/CREATE_NOTIFICATION_SUCCESS'
const CREATE_NOTIFICATION_FAILURE = 'Notification/CREATE_NOTIFICATION_FAILURE'

const UPDATE_NOTIFICATION_REQUEST = 'Notification/UPDATE_NOTIFICATION_REQUEST'
const UPDATE_NOTIFICATION_SUCCESS = 'Notification/UPDATE_NOTIFICATION_SUCCESS'
const UPDATE_NOTIFICATION_FAILURE = 'Notification/UPDATE_NOTIFICATION_FAILURE'

const DELETE_NOTIFICATION_REQUEST = 'Notification/DELETE_NOTIFICATION_REQUEST'
const DELETE_NOTIFICATION_SUCCESS = 'Notification/DELETE_NOTIFICATION_SUCCESS'
const DELETE_NOTIFICATION_FAILURE = 'Notification/DELETE_NOTIFICATION_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  notificationList: { content: [], pageable: {} }
}

// Default Reducer
const notification = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        notificationList: action.payload
      }
    case FETCH_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_NOTIFICATION_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_NOTIFICATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default notification

// Action Creators
export const fetchNotificationList = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_NOTIFICATION_REQUEST
      })

      const response = await API.get(
        EndPoints.NOTIFICATION + `/admin/broadcast`,
        {
          params: options
        }
      )
      dispatch({
        type: FETCH_NOTIFICATION_SUCCESS,
        payload: response.data.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_NOTIFICATION_FAILURE
      })
    }
  }
}

export const createNotification = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_NOTIFICATION_REQUEST
      })

      await API.post(EndPoints.NOTIFICATION + `/admin/broadcast`, data)
      dispatch({
        type: CREATE_NOTIFICATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_NOTIFICATION_FAILURE
      })
    }
  }
}

export const updateNotification = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_NOTIFICATION_REQUEST
      })

      await API.put(EndPoints.NOTIFICATION + `/admin/broadcast`, data)
      dispatch({
        type: UPDATE_NOTIFICATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_NOTIFICATION_FAILURE
      })
    }
  }
}

export const deleteNotification = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_NOTIFICATION_REQUEST
      })

      await API.delete(EndPoints.NOTIFICATION + `/admin/broadcast/${id}`)
      dispatch({
        type: DELETE_NOTIFICATION_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_NOTIFICATION_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/notification.js